// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__35dad","title":"BackImages_title__sA1x2","images":"BackImages_images__2cibx"};